import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import RewardTypeModal from "../Modals/RewardTypeModal";
import PhysicalCardsRequestModal from "../Modals/PhysicalCardsRequestModal";
import { Button, Icon, Typography } from "@plum-xoxo/admin-dsm";
import profileService from "../../services/profileService";
import "./l4InfoPage.scss";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import ContactUsModal from "./ContactUsModal";

const LargeButton = styled(Button)`
  padding: 16px;
  span {
    font-size: 16px;
  }
`;

const L4InfoPage = ({ title, cardData, onGoBack, accountReducer }) => {
  const history = useHistory();
  const [showRewardTypeModal, setShowRewardTypeModal] = useState(false);
  const [showPhysicalCardsModal, setShowPhysicalCardsModal] = useState(false);
  const [showContactUsModal, setShowContactUsModal] = useState(false);
  const [isCreateCampaignLoading, setIsCreateCampaignLoading] = useState(false);
  const [type, setType] = useState(["code"]);
  const location = useLocation();

  const isPhysicalCard =
    cardData?.title?.toLowerCase().includes("physical") ||
    cardData?.subtitle?.toLowerCase().includes("physical");

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle case when cardData is null
  if (!cardData) {
    return (
      <div className="l4-info-page">
        <div className="top-header">
          <div className="top-header-content">
            <div className="header-left">
              <Button
                variant="plain"
                color="primary"
                onClick={onGoBack}
                endIcon={
                  <Icon iconName="PlumChevronRight" size={18} fill="#0245F0" />
                }
                className="cursor-pointer"
              >
                Go Back
              </Button>
              <h3 className="card-name">No Card Selected</h3>
              <p className="card-subtext">
                Please select a card to view details.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const getEventPayload = (campaign) => {
    return {
      url: campaign?.url,
      template_data: campaign?.template_data,
      event_campaign_unique_id: campaign?.event_campaign_unique_id,
      camp_name: campaign?.name,
      urlPrefix: accountReducer?.platformSettings?.urlPrefix,
      type: type[0],
    };
  };

  const createEventCampaign = async (campaign) => {
    const payload = getEventPayload(campaign);
    setIsCreateCampaignLoading(true);
    try {
      const resp = await profileService.createEventCampaign(payload);
      const newCampaignName = resp?.createEventCampaign?.data?.camp_name;

      setIsCreateCampaignLoading(false);
      if (resp?.createEventCampaign?.success) {
        if (newCampaignName) {
          sessionStorage.setItem("newCampaignName", newCampaignName);
        }
        return history.push({
          pathname: `${location.pathname}/${
            type[0].includes("link") ? "send-link" : "send"
          }/`,
          state: JSON.stringify({
            smsText: campaign?.sms_text,
            campaignBudget: campaign?.budget,
            campaignName: newCampaignName,
          }),
        });
      }
    } catch (error) {
      console.error("Error creating event campaign:", error);
      setIsCreateCampaignLoading({ [campaign.name]: false });
    }
  };

  const handleSendNow = () => {
    if (cardData?.mapped_campaign?.[0]) {
      createEventCampaign(cardData?.mapped_campaign?.[0]);
    } else if (isPhysicalCard) {
      // Show physical cards request modal
      setShowContactUsModal(true);
    } else {
      // Show the reward type selection modal
      setShowRewardTypeModal(true);
    }
  };

  const handleCloseModal = () => {
    setShowRewardTypeModal(false);
  };

  const handleClosePhysicalCardsModal = () => {
    setShowPhysicalCardsModal(false);
  };

  const handleContactUsModal = () => {
    setShowContactUsModal(true);
  };

  const handleGoBack = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      history.goBack();
    }
  };

  // Get dynamic steps data based on the card
  const steps = cardData?.steps || {};

  // Use card-specific steps if available, otherwise use default steps
  const displaySteps = steps.length > 0 ? steps : null;

  return (
    <div>
      <div>
        <div>
          <Typography.ButtonText
            color="primary"
            shade="c02"
            onClick={handleGoBack}
            className="cursor-pointer"
          >
            Go Back
          </Typography.ButtonText>
        </div>
        <div className="d-flex justify-content-between align-items-center mt-8">
          <div>
            <Typography.H2 color="dark" shade="c300">
              {cardData?.title || "Send Digital Gifts"}
            </Typography.H2>
            <Typography color="dark" shade="c200" className="mb-0">
              {cardData?.subtitle ||
                "A digital card that users can redeem on gift cards, merchandise & more."}
            </Typography>
          </div>
          <div>
            {!isPhysicalCard && (
              <LargeButton
                variant="outlined"
                color="primary"
                onClick={handleContactUsModal}
                size="large"
                className="mr-20"
              >
                Contact Us
              </LargeButton>
            )}
            <LargeButton
              color="primary"
              onClick={handleSendNow}
              size="large"
              loading={isCreateCampaignLoading}
              disabled={isCreateCampaignLoading}
            >
              Send Now
            </LargeButton>
          </div>
        </div>
      </div>

      <div className="box p-24 mt-20">
        <Typography.H3 color="dark" shade="c300">
          How It Works
        </Typography.H3>
        <div className="mt-8">
          {displaySteps.map((step, index) => (
            <div
              key={index}
              className={`d-flex align-items-center my-20 ${
                index % 2 !== 0
                  ? "flex-row-reverse  justify-content-end"
                  : "  justify-content-start"
              }`}
              style={{ gap: "100px" }}
            >
              <div style={{ width: "384px" }}>
                <img
                  src={step?.image}
                  alt={step?.alt}
                  style={{ width: "100%" }}
                />
              </div>
              <div style={{ width: "384px" }}>
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  className="mb-4"
                >
                  {" "}
                  Step {step?.id}
                </Typography.BodySmall>
                <Typography.ButtonText color="dark" shade="c300">
                  {step.title}
                </Typography.ButtonText>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="box p-32 mt-24 w-100 text-center">
        <Typography.ButtonText
          color="dark"
          shade="c300"
          style={{ width: "394px" }}
          className="mx-auto"
        >
          Gift your users the joy of picking something they truly love this
          Diwali.
        </Typography.ButtonText>
        <LargeButton
          color="primary"
          onClick={handleSendNow}
          size="large"
          className="mt-24 "
          loading={isCreateCampaignLoading}
          disabled={isCreateCampaignLoading}
        >
          Send Now
        </LargeButton>
      </div>

      {/* Reward Type Selection Modal */}
      <RewardTypeModal
        isOpen={showRewardTypeModal}
        onClose={handleCloseModal}
        cardData={cardData}
      />

      {/* Physical Cards Request Modal */}
      <PhysicalCardsRequestModal
        isOpen={showPhysicalCardsModal}
        onClose={handleClosePhysicalCardsModal}
      />

      <ContactUsModal
        title={title + " - " + cardData?.title}
        cardTitle={cardData?.title || "Diwali Gifts"}
        showContactUsModal={showContactUsModal}
        setShowContactUsModal={setShowContactUsModal}
      />
    </div>
  );
};

export default L4InfoPage;
